import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 8px;
  height: 16px;
  color: #9b9b9b;
`

const DraggableSelected = ({ title = 'Draggable Selected', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 8 16" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="surveys-questions-answers-moving" transform="translate(-337.000000, -661.000000)" fill="currentColor">
        <g id="surveys-audience2">
          <g id="question-2" transform="translate(317.000000, 510.000000)">
            <g id="Add-questions-Copy" transform="translate(8.000000, 2.000000)">
              <g id="change-order---outline">
                <g id="change-order---selected" transform="translate(12.000000, 149.000000)">
                  <polygon id="Shape" points="8 5.71428571 0 5.71428571 4 0" />
                  <polygon
                    id="Shape-Copy"
                    transform="translate(4.000000, 12.457143) scale(1, -1) translate(-4.000000, -12.457143) "
                    points="8 15.3142857 0 15.3142857 4 9.6"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

DraggableSelected.displayName = 'DraggableSelected'
DraggableSelected.needsWork = true
export default DraggableSelected
